import { apiServices } from '../services/api.services';
import store from '../store';
import errorsHandled from '../../variables/errorsHandled';
import { toast } from 'react-toastify';
import i18n from '../../i18n';

export const alarmDelete = (id) => {
    return async (Dispatch) => {
        var args = {id};
        await apiServices.post("/deleteDevice", args).then((res) => {
            Dispatch({type: 'ALARM_DELETE', id});
        }).catch(err => {
            return err;
        });   
    };
};

export const alarmEnterEditMode = (id) => {
  return async (Dispatch) => {
    Dispatch({type: 'ALARM_ENTER_EDIT', id});
  };
}

export const alarmCancelEditMode = (id) => {
  return async (Dispatch) => {
    Dispatch({type: 'ALARM_CANCEL_EDIT', id});
  }
}

const deviceName = /^[\p{L} \-\d]{0,24}$/u;
const alarmText = /^[\p{L} \-\d]{0,56}$/u;

export const alarmPreEdit = (id, part, value) => {
  if (part === "text") {
    if (!alarmText.test(value)) return
  } else if(part === "name") {
    if (!deviceName.test(value)) return;
  }
  return async (Dispatch) => {
    Dispatch({type: 'ALARM_PRE_EDIT', id, part, value});
    if (["everyone"].includes(part)) {
      var devices = store.getState().devices.alarms;
      const index = devices.findIndex((d) => d.id === id);
      alarmConfirmEdit(id, devices[index].edit.name, devices[index].edit.text, devices[index].edit.everyone);
    }
  }
}
export const alarmConfirmEdit = (id, name, text, everyone) => {
  var devices = store.getState().devices.alarms;
  const index = devices.findIndex((d) => d.id === id);
  var edited = true;
  if (index === -1) return;
  if (devices[index].name === name && devices[index].text === text && devices[index].everyone === everyone) 
    edited = false;
  if (!edited) return;
  const args = {
    id,
    name,
    text,
    everyone: everyone.toString()
  };
  apiServices.post("/updateDevice", args).then((res) => {
    if (res && res.data) {
      if (res.data.success) store.dispatch({type: 'ALARM_EDIT_UPDATE', id, name, text, everyone});
      if (res.data.error && res.data.code) {
        if (errorsHandled.includes(res.data.code)) {
          if (res.data.code === "9002" || res.data.code === "9003" || res.data.code === "9004") {
            apiServices.refreshServersAndDevices();
            toast.info(i18n.t(`devices:error:wrongDevice`));
          } else toast.error(i18n.t(`devices:error:${res.data.code}`));
        }
      }
    } else store.dispatch({type: 'ALARM_EDIT_RESET', id});
  }).catch(err => {
    return store.dispatch({type: 'ALARM_EDIT_RESET', id});
  });
}